import createStore from 'global/helpers/createStore'
import { type ErrorMessage } from 'global/helpers/requestError'
import { type GeoPoint, type ParkingLocation, ParkingLocationType } from 'screens/TripDetails/TripDetails.types'

export interface TripDetailsState {
  detailsView: string
  activeStopsGroup: number | string | null
  stopsErrors: ErrorMessage[]
  focusGeoPoint?: GeoPoint
  parkingLocationTypes: ParkingLocationType[]
  parkingLocationFocus?: ParkingLocation
}

export type TripDetailsAction =
  | { type: 'setDetailsView'; payload: string }
  | { type: 'setActiveStopsGroup'; payload: number | string | null }
  | { type: 'setStopsErrors'; payload: ErrorMessage[] }
  | { type: 'clearStopsErrors' }
  | { type: 'setFocusGeoPoint'; payload?: GeoPoint }
  | { type: 'setParkingLocationTypes'; payload: ParkingLocationType[] }
  | { type: 'setParkingLocationFocus'; payload: ParkingLocation }

const initialState: TripDetailsState = {
  detailsView: 'shipments',
  activeStopsGroup: null,
  stopsErrors: [],
  focusGeoPoint: undefined,
  parkingLocationTypes: Object.keys(ParkingLocationType) as ParkingLocationType[],
  parkingLocationFocus: undefined
}

const reducer = (state: TripDetailsState, action: TripDetailsAction): TripDetailsState => {
  switch (action.type) {
    case 'setDetailsView':
      return {
        ...state,
        detailsView: action.payload,
        focusGeoPoint: undefined
      }
    case 'setActiveStopsGroup':
      return {
        ...state,
        activeStopsGroup: action.payload
      }
    case 'setStopsErrors':
      return {
        ...state,
        stopsErrors: action.payload
      }
    case 'clearStopsErrors':
      return {
        ...state,
        stopsErrors: []
      }
    case 'setFocusGeoPoint':
      return {
        ...state,
        focusGeoPoint: action.payload
      }
    case 'setParkingLocationTypes':
      return {
        ...state,
        parkingLocationTypes: action.payload
      }
    case 'setParkingLocationFocus':
      return {
        ...state,
        parkingLocationFocus: state.parkingLocationFocus !== action.payload ? action.payload : initialState.parkingLocationFocus,
        focusGeoPoint: state.focusGeoPoint !== action.payload.geometry.coordinates[0] ? action.payload.geometry.coordinates[0] : initialState.focusGeoPoint
      }
    default:
      throw new Error('Invalid action type')
  }
}

const { StoreContext, StoreProvider } = createStore(reducer, initialState)

export { StoreContext as TripDetailsContext, StoreProvider as TripDetailsProvider }
